module.exports = "pegasus_template/assets/background-patterns/subtle-blue-mini-waves.png";